import React, { useRef } from "react";
import { Container, ContentWrap, TextBox1, TextBox2, TextBox3, TextBoxWrap } from "./style";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
import { useNavigate } from "react-router";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com3 = () => {
  const { t } = useTranslation("howToGetSketch");
  const language = useSelector(selectLanguage);
  const nav = useNavigate();
  const navHandler = () => {
    nav("/using_wallet");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  useScrollFadeIn(ref1, ref2, ref3, ref4);
  return (
    <Container>
      <TextBox1>
        <div>
          <span>{t("3-2")}</span>
          <span>{t("3-2-1")}</span>
        </div>
        <div>{t("3-3")}</div>
      </TextBox1>
      <ContentWrap>
        <TextBoxWrap>
          <TextBox2 ref={ref1} className="fade-in">
            <div>{t("3-4")}</div>
            <div>
              <span> {t("3-5")}</span>
              <span> {t("3-6")}</span>
              <span> {t("3-7")}</span>
            </div>
          </TextBox2>
          <TextBox2 language={language} ref={ref2} className="fade-in">
            <div>{t("3-8")}</div>
            <div>
              <span>{t("3-9")}</span>
              <span>{t("3-10")}</span>
            </div>
          </TextBox2>
          <TextBox3 onClick={navHandler} ref={ref4} className="fade-in">
            {t("3-11")}
          </TextBox3>
          <TextBox2 language={language} ref={ref3} className="fade-in">
            <div>{t("3-12")}</div>
            <div>
              <span>{t("3-13")}</span>
              <span>{t("3-13-1")}</span>
              <span>{t("3-14")}</span>
            </div>
          </TextBox2>
        </TextBoxWrap>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/d4ecba99HowToGetSKET_6.svg"
          alt="roadMap"
        />
      </ContentWrap>
    </Container>
  );
};

export default Com3;
